/* ============================================================
   ESCORPIÓN — Mega menú con íconos (oct 2026)
   · Escritorio: pasar el mouse (o el foco) por una pestaña muestra su panel; el clic navega.
   · Cajón móvil: el contenido se copia del mega menú de escritorio al abrir cada sección;
     tocar una pestaña cambia el panel (no navega: para eso está "Ver toda…").
   ============================================================ */
(function () {
  function activar(caja, tab) {
    var id = tab.getAttribute('data-tab');
    caja.querySelectorAll('.esc-mmx__tab').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', String(on));
    });
    caja.querySelectorAll('.esc-mmx__panel').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === id); });
    // Al mostrarse un panel, sus escudos se piden ya (si no, se ven en blanco un instante)
    caja.querySelectorAll('.esc-mmx__panel.is-on img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }

  function preparar(caja, enCajon) {
    if (caja.dataset.listo) return;
    caja.dataset.listo = '1';
    caja.querySelectorAll('.esc-mmx__tab').forEach(function (tab) {
      if (enCajon) {
        tab.addEventListener('click', function (e) { e.preventDefault(); activar(caja, tab); });
      } else {
        var t;
        tab.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { activar(caja, tab); }, 70); });
        tab.addEventListener('mouseleave', function () { clearTimeout(t); });
        tab.addEventListener('focus', function () { activar(caja, tab); });
      }
    });
  }

  function arrancar() {
    document.querySelectorAll('.esc-mm [data-esc-mmx]').forEach(function (c) { preparar(c, false); });
    document.querySelectorAll('.esc-hdr__nav-item--mega').forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        li.querySelectorAll('.esc-mmx__tabs img, .esc-mmx__panel.is-on img, .esc-mmx--simple img').forEach(function (i) { i.loading = 'eager'; });
      }, { once: true });
    });
    // Cajón móvil: copia perezosa del contenido al abrir cada sección
    document.querySelectorAll('[data-esc-mmx-clon]').forEach(function (destino) {
      var btn = destino.closest('.esc-drawer__item') && destino.closest('.esc-drawer__item').querySelector('.esc-drawer__accordion-btn');
      var llenar = function () {
        if (destino.childElementCount) return;
        var origen = document.querySelector('.esc-mm [data-esc-mmx="' + destino.getAttribute('data-esc-mmx-clon') + '"]');
        if (!origen) return;
        var copia = origen.cloneNode(true);
        delete copia.dataset.listo;
        copia.removeAttribute('data-listo');
        destino.appendChild(copia);
        preparar(copia, true);
      };
      if (btn) btn.addEventListener('click', llenar);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
